import { createContext, useContext } from "react";
import { RouteDescription } from "./types";

export const RoutesContext = createContext<RouteDescription[]>([]);

export function useRoutesContext<T extends RouteDescription>() {return useContext(RoutesContext) as T[];}